import React from 'react';
import Chip from './Chip';

export default function AlertRow({ alerts = [] }) {
  if (!alerts.length) {
    return (
      <div className="rounded-lg border border-emerald-100 bg-emerald-50 px-3 py-2 text-sm text-emerald-800">
        Liquidity healthy across the modeled horizon.
      </div>
    );
  }
  const primary = alerts[0];
  const tone =
    primary.severity === 'critical'
      ? 'critical'
      : primary.severity === 'warning'
        ? 'warning'
        : 'info';
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2">
      <Chip tone={tone}>
        {primary.severity === 'critical'
          ? 'Cash shortfall projected'
          : primary.severity === 'warning'
            ? 'Cash tight'
            : 'Cash flow note'}
      </Chip>
      <span className="text-sm text-gray-700">{primary.message}</span>
      {alerts.slice(1).map((alert) => (
        <Chip key={`${alert.code}-${alert.message}`} tone={alert.severity}>
          {alert.message}
        </Chip>
      ))}
    </div>
  );
}
